import { render } from "./emailTemplates.vue?vue&type=template&id=9752ae64"
import script from "./emailTemplates.vue?vue&type=script&lang=js"
export * from "./emailTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__